import { Pill } from "@/components/ui";

const MON = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];

/** EOD-freshness pill shown next to each account's Daily-P&L number. "EOD
 *  TODAY" when the account's latest loaded day is today, otherwise
 *  "EOD 08JUL" (day + 3-letter month — unambiguous, matches the 2026JUL cycle
 *  style; a bare 07-08 read as confusing). A quick per-account signal that not
 *  every account updates every day. Uses the subtle grey `outline` variant
 *  (same as the NSE/BSE exchange pills). `isToday` is computed server-side (vs
 *  CURDATE()) to avoid browser TZ drift. */
export function EodPill({ date, isToday }: { date: string; isToday: boolean }) {
  const [, m, d] = date.split("-");
  return (
    <Pill variant="outline" size="sm">
      {isToday ? "EOD TODAY" : `EOD ${d}${MON[Number(m) - 1] ?? ""}`}
    </Pill>
  );
}
